
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CheckIcon extends Vue {
  @Prop({ default: '17' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
